import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';

import type { PageConfig } from 'src/libs/PageConfig';
import type { TrackStatusUpdateAttributes } from 'src/utils/eventsTypes';

import type { IAttachmentsStore } from '../../../stores/JobApplicationStore/AttachmentsStore';
import type { INotes } from '../../../stores/JobApplicationStore/Notes';
import Attachments from '../Attachments';
import Notes from '../Notes';

import translations from './.vocab';

import * as styles from './ItemContent.css';

interface NotesAttachmentsProps {
  notes: INotes;
  attachmentsStore: IAttachmentsStore;
  locale: Locale;
  isVerifiedId: TrackStatusUpdateAttributes['isVerifiedId'];
  jobId: string;
  applicationCorrelationId: string;
  addCustomError: PageConfig['dataDogRum']['addCustomError'];
}
const NotesAttachments = ({
  notes,
  attachmentsStore,
  locale,
  isVerifiedId,
  jobId,
  applicationCorrelationId,
  addCustomError,
}: NotesAttachmentsProps) => {
  const { t } = useTranslations(translations);
  return (
    <Box marginBottom="medium" className={styles.notesAttachmentsContainer}>
      <Stack space="xlarge">
        <Stack space="medium">
          <Heading level="4">{t('Notes')}</Heading>
          <Notes
            notes={notes}
            locale={locale}
            jobId={jobId}
            applicationCorrelationId={applicationCorrelationId}
            addCustomError={addCustomError}
          />
        </Stack>

        <Stack space="medium">
          <Heading level="4">{t('Attachments')}</Heading>
          <Attachments
            attachmentsStore={attachmentsStore}
            locale={locale}
            isVerifiedId={isVerifiedId}
            addCustomError={addCustomError}
            jobId={jobId}
            applicationCorrelationId={applicationCorrelationId}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default observer(NotesAttachments);
